<button mat-stroked-button color="primary" [matMenuTriggerFor]="columnMenu">
   Edit Columns
   <mat-icon>arrow_drop_down</mat-icon>
</button>
<mat-menu #columnMenu>
   <div class="mat-menu-item" *ngFor="let col of columns" (click)="updateColumn($event, col)">
      <mat-checkbox color="primary" [checked]="col.visible">
         {{ col.label }}
      </mat-checkbox>
   </div>
</mat-menu>
